import { Container } from './styles';

type ConsultScheduleButtonProps = {
  handleConsultSchedule: () => void;
};

const ConsultScheduleButton = ({
  handleConsultSchedule
}: ConsultScheduleButtonProps) => {
  return (
    <Container onClick={handleConsultSchedule}>Consultar agendamento</Container>
  );
};

export default ConsultScheduleButton;
